export const hoursList: { value: string, label: string }[] = [
  { value: "-1", label: "Selecione" },
  { value: "1", label: "1 Hora" },
  { value: "2", label: "2 Horas" },
  { value: "3", label: "3 Horas" },
  { value: "4", label: "4 Horas" },
  { value: "5", label: "5 Horas" },
  { value: "6", label: "6 Horas" },
  { value: "7", label: "7 Horas" },
  { value: "8", label: "8 Horas" },
  { value: "9", label: "9 Horas" },
  { value: "10", label: "10 Horas" },
  { value: "11", label: "11 Horas" },
  { value: "12", label: "12 Horas" },
  { value: "13", label: "13 Horas" },
  { value: "14", label: "14 Horas" },
  { value: "15", label: "15 Horas" },
  { value: "16", label: "16 Horas" },
  { value: "17", label: "17 Horas" },
  { value: "18", label: "18 Horas" },
  { value: "19", label: "19 Horas" },
  { value: "20", label: "20 Horas" },
  { value: "21", label: "21 Horas" },
  { value: "22", label: "22 Horas" },
  { value: "23", label: "23 Horas" },
  { value: "24", label: "24 Horas" }
];
